/** @format */

import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import Loader from '@components/loader';
import { safeCurrentLanguage } from '@services/drupal-services';

const GoogleLocatorPage = lazy(
  () =>
    import(
      /* webpackChunkName: "google-locator-page" */ './google-locator-page'
    )
);

const BingLocatorPage = lazy(
  () =>
    import(/* webpackChunkName: "bing-locator-page" */ './bing-locator-page')
);

/**
 * Treatment Locator.
 */
export const treatmentLocator = (): void => {
  const locatorContainer: HTMLElement =
    document.getElementById('varian-locator-map');
  if (locatorContainer) {
    const root = createRoot(locatorContainer);
    if (
      safeCurrentLanguage() === 'zh-hant' ||
      safeCurrentLanguage() === 'zh-hans'
    ) {
      root.render(
        <Suspense fallback={<Loader />}>
          <BingLocatorPage />
        </Suspense>
      );
    } else {
      root.render(
        <Suspense fallback={<Loader />}>
          <GoogleLocatorPage />
        </Suspense>
      );
    }
  }
};
